/**
 * The one substitutable seam under the API client (request-client-seam 01).
 *
 * A transport answers a path with a `Response`, exactly like `fetch`. Tests
 * swap the singleton transport for a fake; production uses `fetchTransport`.
 * Nothing above this seam knows whether a request left the process.
 */
export type Transport = (path: string, init?: RequestInit) => Promise<Response>;

/** The production adapter: the browser's `fetch`, looked up at call time. */
export const fetchTransport: Transport = (path, init) => fetch(path, init);

let activeTransport: Transport = fetchTransport;

/** The transport every request uses right now. */
export function getTransport(): Transport {
  return activeTransport;
}

/**
 * Replace the transport for every subsequent request. Callers that build a
 * `Requests` object must read through `getTransport()` rather than capture a
 * transport at import time, or this becomes inert.
 */
export function setTransport(transport: Transport): void {
  activeTransport = transport;
}
